<script>
import { mapActions } from 'vuex';
import axios from 'axios';

export default {
  name: 'ResetPassword',
  data() {
    return {
      email: '',
      newPassword: '',
      confirmPassword: '',
      hasError: false,
      isLoading: false,
      isSuccess: false,
      oobCode: null,
    };
  },
  async created() {
    this.oobCode = this.$route.query.oobCode; // URL'den oobCode al
    if (this.oobCode) {
      await this.validateOobCode(this.oobCode);
    } else {
      this.hasError = true;
    }
  },
  methods: {
    ...mapActions('app', ['changePassword']),
    
    async validateOobCode(oobCode) {
      try {
        this.isLoading = true; // Yükleniyor durumunu başlat
        const response = await axios.get(`Access/ValidateOobCode?code=${oobCode}`);

        if (response.status === 200 && response.data == true) {
          // OobCode geçerli, sayfa yüklenebilir
          this.isLoading = false;
        } else {
          this.hasError = true;
        }
      } catch (error) {
        this.hasError = true;
      }
    },
    
    async submit() {
      this.isLoading = true;
      this.hasError = false;

      if (this.newPassword !== this.confirmPassword) {
        this.hasError = true;
        this.isLoading = false;
        return;
      }

      try {
        const response = await this.changePassword({ email: this.email,  password: this.newPassword, oobCode: this.oobCode });
        if (response.status === 200 && response.data == true) {
          // OobCode geçerli, sayfa yüklenebilir
          this.isLoading = false;
          this.isSuccess = true;
          this.$router.push({ path: '/login' }); // Giriş sayfasına yönlendir
        } else {
          this.hasError = true;
        }
      } catch (error) {
        console.error('Şifre değiştirme hatası:', error);
        this.hasError = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4 lg4 xl2>
          <v-card class="elevation-12">
            <v-toolbar dark color="#B4C3C0">
              <v-toolbar-title>Şifre Sıfırlama</v-toolbar-title>
              <v-spacer />
            </v-toolbar>

            <v-card-text>
              <v-form @submit.prevent="submit">
                <v-text-field
                  v-model="email"
                  label="Email"
                  required
                />
                <v-text-field
                  v-model="newPassword"
                  label="Yeni Şifre"
                  type="password"
                  required
                />
                <v-text-field
                  v-model="confirmPassword"
                  label="Yeni Şifre (Tekrar)"
                  type="password"
                  clearable
                  required
                />
                <v-btn dark color="green" type="submit" style="width: 100%;">
                  <span>{{ isLoading ? 'Yükleniyor...' : 'Şifreyi Değiştir' }}</span>
                </v-btn>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <span v-if="hasError" style="color: red;">Bir hata oluştu. Lütfen tekrar deneyin!</span>
              <span v-if="isSuccess" style="color: green;">Şifreniz başarıyla değiştirildi.</span>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<style>
.schupy-input-login {
    padding-top: 0px !important;
    margin-top: 0px !important;
}
</style>